import ModuleManager from './models/manager'

export default ModuleManager
